import React from 'react';
import { Link } from 'react-router-dom';
import { PublicLayout } from '../../components/layout';

const AboutUs: React.FC = () => {
  const team = [
    {
      name: 'أحمد محمد العلي',
      position: 'المؤسس والرئيس التنفيذي',
      bio: 'خبير في التكنولوجيا التعليمية مع أكثر من 15 عام في مجال التعليم والتقنية',
    },
    {
      name: 'فاطمة سالم الزهراني',
      position: 'مدير التطوير التقني',
      bio: 'مهندسة برمجيات متخصصة في تطوير المنصات التعليمية والذكاء الاصطناعي',
    },
    {
      name: 'محمد عبدالله القحطاني',
      position: 'مدير التسويق والمبيعات',
      bio: 'خبير في التسويق الرقمي والمبيعات مع تركيز على القطاع التعليمي',
    },
    {
      name: 'نورا خالد الشهري',
      position: 'مدير تجربة العملاء',
      bio: 'متخصصة في تحسين تجربة المستخدم وضمان رضا العملاء',
    },
  ];

  const stats = [
    { number: '1,000+', label: 'معلم نشط' },
    { number: '50,000+', label: 'طالب مستفيد' },
    { number: '200,000+', label: 'حصة تم عقدها' },
  ];

  const values = [
    {
      icon: '🎯',
      title: 'الابتكار',
      description: 'نسعى دائماً لتطوير حلول تقنية مبتكرة تخدم المعلمين والطلاب',
    },
    {
      icon: '🤝',
      title: 'الشراكة',
      description: 'نؤمن بأهمية الشراكة مع عملائنا لتحقيق النجاح المشترك',
    },
    {
      icon: '⭐',
      title: 'الجودة',
      description: 'نلتزم بأعلى معايير الجودة في جميع منتجاتنا وخدماتنا',
    },
    {
      icon: '🌍',
      title: 'التأثير',
      description: 'هدفنا إحداث تأثير إيجابي في مستقبل التعليم عالمياً',
    },
  ];

  const milestones = [
    {
      year: '2024',
      title: 'تأسيس الشركة',
      description: 'بداية الرحلة برؤية واضحة لتطوير التعليم الخصوصي',
    },
    {
      year: '2025',
      title: 'إطلاق النسخة التجريبية',
      description: 'إطلاق النسخة التجريبية الأولى مع 100 معلم',
    },
    {
      year: '2025',
      title: 'النسخة الرسمية',
      description: 'إطلاق المنصة رسمياً ووصول 5,000 معلم',
    },
    {
      year: '2025',
      title: 'التوسع الإقليمي',
      description: 'التوسع لتشمل دول الخليج العربي',
    },
  ];

  return (
    <PublicLayout>
      <div className='bg-gradient-to-br from-primary-50 to-secondary-50 dark:from-secondary-950 dark:to-secondary-900'>
        {/* Hero Section */}
        <div className='bg-gradient-to-r from-primary-600 to-primary-800 text-white py-20 dark:from-secondary-900 dark:to-primary-950'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='text-center'>
              <h1 className='text-4xl md:text-6xl font-bold mb-6'>من نحن</h1>
              <p className='text-xl md:text-2xl text-primary-100 max-w-4xl mx-auto'>
                نحن فريق متحمس لتطوير مستقبل التعليم من خلال التكنولوجيا
                المبتكرة والحلول الذكية
              </p>
            </div>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20'>
          <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20'>
            <div className='bg-white rounded-2xl shadow-lg p-8 dark:bg-secondary-900 dark:border dark:border-secondary-800'>
              <div className='text-4xl mb-6'>🎯</div>
              <h2 className='text-3xl font-bold text-secondary-900 dark:text-white mb-4'>
                رسالتنا
              </h2>
              <p className='text-lg text-secondary-700 dark:text-secondary-300 leading-relaxed'>
                تمكين المعلمين من تقديم تعليم عالي الجودة وإدارة أعمالهم بكفاءة
                من خلال منصة تقنية شاملة ومبتكرة تجمع بين سهولة الاستخدام
                والوظائف المتقدمة، مما يساهم في تحسين نتائج التعلم وتعزيز تجربة
                الطلاب التعليمية.
              </p>
            </div>

            <div className='bg-white rounded-2xl shadow-lg p-8 dark:bg-secondary-900 dark:border dark:border-secondary-800'>
              <div className='text-4xl mb-6'>🌟</div>
              <h2 className='text-3xl font-bold text-secondary-900 dark:text-white mb-4'>
                رؤيتنا
              </h2>
              <p className='text-lg text-secondary-700 dark:text-secondary-300 leading-relaxed'>
                أن نكون المنصة الرائدة عالمياً لإدارة التعليم الخصوصي، ونساهم في
                إعادة تشكيل مستقبل التعليم من خلال الابتكار التقني والتركيز على
                احتياجات المعلمين والطلاب، لنصل إلى عالم يحصل فيه كل طالب على
                تعليم مخصص وعالي الجودة.
              </p>
            </div>
          </div>

          {/* Stats */}
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20'>
            {stats.map((stat, index) => (
              <div key={index} className='text-center'>
                <div className='text-4xl font-bold text-primary-600 mb-2'>
                  {stat.number}
                </div>
                <div className='text-lg text-secondary-700 dark:text-secondary-300'>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Our Story */}
        <div className='bg-white py-20 dark:bg-secondary-950'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='text-center mb-16'>
              <h2 className='text-4xl font-bold text-secondary-900 dark:text-white mb-6'>
                قصتنا
              </h2>
              <p className='text-xl text-secondary-600 dark:text-secondary-300 max-w-3xl mx-auto'>
                بدأت رحلتنا من ملاحظة التحديات التي يواجهها المعلمون في إدارة
                أعمالهم التعليمية
              </p>
            </div>

            <div className='grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16'>
              <div>
                <h3 className='text-2xl font-bold text-secondary-900 dark:text-white mb-4'>
                  التحدي الذي واجهناه
                </h3>
                <p className='text-secondary-700 dark:text-secondary-300 leading-relaxed mb-6'>
                  لاحظنا أن العديد من المعلمين المتميزين يواجهون صعوبات في إدارة
                  جوانب أعمالهم غير التدريسية، مثل جدولة الحصص، متابعة
                  المدفوعات، وتتبع تقدم الطلاب. هذا كان يستنزف وقتهم وطاقتهم
                  التي يجب أن تُركز على التدريس.
                </p>
                <p className='text-secondary-700 dark:text-secondary-300 leading-relaxed'>
                  من هنا جاءت فكرة Class-Tech - منصة شاملة تجمع كل ما يحتاجه
                  المعلم في مكان واحد، مما يتيح له التركيز على ما يجيده أكثر:
                  التدريس وإلهام الطلاب.
                </p>
              </div>
              <div className='bg-gradient-to-br from-primary-100 to-secondary-100 rounded-2xl p-8 text-center dark:from-secondary-900 dark:to-secondary-800'>
                <div className='text-6xl mb-4'>💡</div>
                <h4 className='text-xl font-semibold text-secondary-900 dark:text-white mb-2'>
                  الفكرة الأساسية
                </h4>
                <p className='text-secondary-700 dark:text-secondary-300'>
                  "ماذا لو كان بإمكان المعلمين إدارة كل شيء من مكان واحد؟"
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className='bg-secondary-50 py-20 dark:bg-secondary-950'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='text-center mb-16'>
              <h2 className='text-4xl font-bold text-secondary-900 dark:text-white mb-6'>
                رحلتنا عبر السنوات
              </h2>
              <p className='text-xl text-secondary-600 dark:text-secondary-300'>
                من الفكرة الأولى إلى المنصة الرائدة التي نحن عليها اليوم
              </p>
            </div>

            <div className='relative'>
              <div className='absolute right-1/2 transform translate-x-1/2 h-full w-1 bg-primary-200'></div>
              <div className='space-y-12'>
                {milestones.map((milestone, index) => (
                  <div
                    key={index}
                    className={`flex items-center ${
                      index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                    }`}
                  >
                    <div
                      className={`w-1/2 ${
                        index % 2 === 0 ? 'text-left pl-8' : 'text-right pr-8'
                      }`}
                    >
                      <div className='bg-white rounded-lg shadow-md p-6 dark:bg-secondary-900 dark:border dark:border-secondary-800'>
                        <div className='text-primary-600 font-bold text-lg mb-2'>
                          {milestone.year}
                        </div>
                        <h3 className='text-xl font-semibold text-secondary-900 dark:text-white mb-2'>
                          {milestone.title}
                        </h3>
                        <p className='text-secondary-700 dark:text-secondary-300'>
                          {milestone.description}
                        </p>
                      </div>
                    </div>
                    <div className='w-4 h-4 bg-primary-500 rounded-full absolute right-1/2 transform translate-x-1/2 border-4 border-white dark:border-secondary-950'></div>
                    <div className='w-1/2'></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className='bg-white py-20 dark:bg-secondary-950'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='text-center mb-16'>
              <h2 className='text-4xl font-bold text-secondary-900 dark:text-white mb-6'>
                قيمنا الأساسية
              </h2>
              <p className='text-xl text-secondary-600 dark:text-secondary-300'>
                المبادئ التي توجه عملنا وقراراتنا كل يوم
              </p>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8'>
              {values.map((value, index) => (
                <div key={index} className='text-center'>
                  <div className='bg-primary-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 dark:bg-primary-950'>
                    <span className='text-3xl'>{value.icon}</span>
                  </div>
                  <h3 className='text-xl font-bold text-secondary-900 dark:text-white mb-3'>
                    {value.title}
                  </h3>
                  <p className='text-secondary-600 dark:text-secondary-300'>{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Team */}
        <div className='bg-secondary-50 py-20 dark:bg-secondary-950'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='text-center mb-16'>
              <h2 className='text-4xl font-bold text-secondary-900 dark:text-white mb-6'>
                فريق العمل
              </h2>
              <p className='text-xl text-secondary-600 dark:text-secondary-300'>
                تعرّف على الأشخاص الذين يقودون ثورة التعليم التقني
              </p>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8'>
              {team.map((member, index) => (
                <div
                  key={index}
                  className='bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow p-6 text-center dark:bg-secondary-900 dark:border dark:border-secondary-800'
                >
                  <div className='w-24 h-24 bg-gradient-to-br from-primary-100 to-cyan-100 rounded-full mx-auto mb-4 flex items-center justify-center text-primary-700'>
                    <span className='text-2xl font-bold'>
                      {member.name
                        .split(' ')
                        .slice(0, 2)
                        .map(part => part[0])
                        .join('')}
                    </span>
                  </div>
                  <h3 className='font-bold text-secondary-900 dark:text-white mb-1'>
                    {member.name}
                  </h3>
                  <p className='text-primary-600 text-sm mb-3'>
                    {member.position}
                  </p>
                  <p className='text-xs text-secondary-600 dark:text-secondary-300 leading-relaxed'>
                    {member.bio}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className='bg-secondary-900 text-white py-20'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center'>
            <h2 className='text-4xl font-bold mb-6'>انضم إلى رحلتنا</h2>
            <p className='text-xl text-secondary-300 mb-8 max-w-2xl mx-auto'>
              كن جزءاً من ثورة التعليم التقني واكتشف كيف يمكن لـ Class-Tech أن
              يغير طريقة عملك
            </p>
            <div className='flex flex-col sm:flex-row gap-4 justify-center'>
              <Link
                to='/register'
                className='bg-primary-600 hover:bg-primary-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors'
              >
                ابدأ التجربة المجانية
              </Link>
              <Link
                to='/contact'
                className='border border-white text-white hover:bg-white hover:text-secondary-900 px-8 py-3 rounded-lg font-semibold transition-all'
              >
                تواصل معنا
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default AboutUs;
